module.exports = __webpack_public_path__ + "static/media/Snorunt_gaussian2.98cd8a3a.png";